import React, { useState, useContext, useEffect } from "react";
import { Col, Modal, Card } from "react-bootstrap";
import { Zoom } from "react-awesome-reveal";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { isMobile } from "react-device-detect";
import SplitNumber from "../../../components/SplitNumber";
import ContextApp from "../../../../core/contexts/context.app";
import ApiAccount from "../../../../core/api/api.account";
import { useForm } from "react-hook-form";
import ApiUserWithdrawal from "../../../../core/api/api.userWithdrawal";
import ApiUserPayment from "../../../../core/api/api.userPayment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import { IconClose, IconWallet } from "../../../../assets/icons";
import WithdrawFromWallet from "../WithdrawFromWallet";
import LoadingDottedButton from "../../../components/LoadingDottedButton";
function WalletItem({ Icon, PageLink, Title, Event, RiallBalance }) {
  let location = useLocation();
  let navigate = useNavigate();
  const env = process.env;

  const [stateTypeAction, setStateTypeAction] = useState(0);
  const [accounts, setAccounts] = useState();
  const [show, setShow] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { isSubmitting: isSubmitting2 },
    setValue: setValue2,
  } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ctx = useContext(ContextApp);

  // const dataForm = {
  //   rialAmount: register("rialAmount", { required: true }),
  //   accountId: register("accountId", { required: true }),
  // };
  const dataForm2 = {
    rialAmount: register2("rialAmount", { required: true }),
  };
  useEffect(() => {
    //if (ctx.isAuth && !_.isEmpty(ctx.userInfo) && !_.isEmpty(_.trim(ctx.userInfo.name))) {
    if (ctx.isAuth) {
    } else {
      //باز کردن لاگین
      let path = "/login";
      navigate(path, { prevPath: location.pathname });
    }
  }, [ctx.isAuth]);

  // const onSubmit = async (data) => {
  //   try {
  //     data.rialAmount = data.rialAmount.split(" ").join("").split(",").join("");

  //     if (parseInt(data.rialAmount) > parseInt(RiallBalance)) {
  //       //toast.configure();
  //       toast("مبلغ وارد شده بیشتر از موجودی کیف پول شماست");
  //       return;
  //     } else {
  //       const response = await ApiUserWithdrawal.createUserWithdrawal({
  //         rialAmount: parseInt(data.rialAmount),
  //         destinationAccountId: parseInt(data.accountId),
  //       });
  //       if (!_.isEmpty(response)) {
  //         //toast.configure();
  //         toast(response.message);
  //         Modal.onHide();
  //       }
  //     }
  //   } catch (error) {}
  // };

  const onSubmit2 = async (data) => {
    try {
      data.rialAmount = data.rialAmount.split(" ").join("").split(",").join("");

      //   ارسال به درگاه پیشفرض
      const response = await ApiUserPayment.insertPayment({
        rialAmount: parseInt(data.rialAmount),
      });

      if (!_.isEmpty(response)) {
        //toast.configure();
        toast(response.message, { position: "top-right" });
        if (
          response.data.message === "CreateLinkeOk" &&
          response.data.basketPaymentStatusId === 1
        )
          window.location.replace(
            env.REACT_APP_API_URL + "/home?redirectId=" + response.data.link
          );
        else if (response.data.Link === "") {
          //toast.configure();
          toast(response.data.message, { position: "top-right" });
        }
      }
    } catch (error) {}
  };

  async function goFunction() {
    if (Event === 1) {
      setStateTypeAction(1);
      handleShow();
    } else if (Event === 2) {
      // try {
      //   // گرفتن لیست حساب ها
      //   const response = await ApiAccount.getAllAccountForUserId();

      //   if (!_.isEmpty(response) && !_.isEmpty(response.data)) {
      //     setAccounts(response.data);
      //   }
      // } catch (error) {}
      // setStateTypeAction(2);
      navigate("/withdrowFromWallet");
    }
  }

  return (
    <>
      <Col xs={6} md="3" lg="6" className=" mb-2 mb-lg-3  large-icons">
        <Zoom className=" h-100">
          <Card
            className="text-center border-0 shadow-sm rounded-3"
            onClick={goFunction}
          >
            <Card.Body>
              {" "}
              <Link to={PageLink}>
                {Icon}
                <div className="text-center pt-2 pb-2 text-dark fs-08 ">
                  {Title}
                </div>
              </Link>
            </Card.Body>
          </Card>
        </Zoom>
      </Col>

      <Modal
        show={show}
        onHide={handleClose}
        centered={isMobile ? false : true}
        className={isMobile ? " modal-bottom " : " modal-rounded "}
      >
        <Modal.Body className="pt-0  pb-lg-4">
          <Col xs={12} className="text-center">
            <div className="close-box" onClick={() => handleClose()}>
              <IconClose fillColor="#5d6d94" />
            </div>
            {/* <X size={25} className="close-box" onClick={() => handleClose()} /> */}
            <div className="float-box-title text-center">
              <IconWallet fillColor="#5d6d94" />
              شارژ کیف پول
            </div>
            <div className="text-muted d-flex justify-content-between px-2 border-bottom py-2 mb-3 fw-bold">
              <div> موجودی کیف پول </div>
              <div>
                <span className="text-dark font-weight-bold">
                  <SplitNumber number={RiallBalance} />
                </span>{" "}
                تومان
              </div>
            </div>
            {stateTypeAction === 1 ? (
              <div>
                <form key={1} onSubmit={handleSubmit2(onSubmit2)}>
                  <div className="text-dark fs-09 pt-2 pb-3 text-justify text-center fw-bold">
                    {" "}
                    جهت شارژ کیف پول، مبلغ موردنظر را وارد نمایید.
                  </div>
                  {/* <Form.Control type="number" className="rounded-pill mb-2 text-center" placeholder="0 تومان" /> */}
                  {/* <NumericFormat
                    {...dataForm2.rialAmount}
                    className="form-control rounded-2 text-center mb-2 "
                    name="rialAmount"
                    suffix="تومان "
                    decimalScale="0"
                    thousandSeparator=","
                   placeholder="0 تومان"
                  />
                  {errors.rialAmount && <span>مبلغ را وارد نمایید</span>} */}
                  <div className="form-control rounded-2 text-center mb-2 d-flex justify-content-between align-items-center">
                    <NumericFormat
                      {...register2("rialAmount", {
                        required: "مبلغ را وارد نمایید!!",
                      })}
                      className="border-0 btn-no-style text-center w-75"
                      // suffix="تومان"
                      decimalScale="0"
                      thousandSeparator=","
                      placeholder="0"
                      maxLength={15}
                      onValueChange={(values) => {
                        const { value } = values;
                        setValue2("rialAmount", value, {
                          shouldValidate: true,
                        });
                      }}
                    />
                    <span className="text-muted w-25">تومان</span>
                  </div>
                  {errors.rialAmount && (
                    <span className="text-danger">
                      {errors.rialAmount.message}
                    </span>
                  )}

                  {!isSubmitting2 ? (
                    <button
                      type="submit"
                      className="btn btn-primary w-100 rounded-2"
                    >
                      افزایش موجودی
                    </button>
                  ) : (
                    <button
                      disabled
                      type="submit"
                      className="btn btn-primary w-100 rounded-2"
                    >
                      <LoadingDottedButton btnText="افزایش موجودی" />
                    </button>
                  )}
                  {/* <Button
                    variant="primary"
                    className="w-100 rounded-2"
                    type="submit"
                    disabled={isSubmitting2}
                  >
                    {isSubmitting2 && (
                      <Spinner animation="border" variant="warning" size="sm" />
                    )}
                    افزایش موجودی
                  </Button> */}
                </form>
              </div>
            ) : (
              <WithdrawFromWallet />
              // <div>
              //   <form key={2} onSubmit={handleSubmit(onSubmit)}>
              //     <div className="text-dark fs-09 pt-2 pb-3 text-justify text-center fw-bold">
              //       جهت برداشت از کیف پول، مبلغ را وارد نمایید.
              //     </div>

              //     {accounts != null && accounts.length > 0 ? (
              //       <>
              //         <Form.Control
              //           {...register("accountId", {
              //             required: "لطفا یکی از کارت ها را انتخاب نمایید",
              //           })}
              //           as="select"
              //           name="accountId"
              //           className="mb-2 rounded-2 d-inline-block text-center"
              //           style={{ width: "calc(100% - 38px)" }}
              //         >
              //           <option value="">شماره کارت</option>
              //           {accounts.map((item, index) => (
              //             <option value={item.value} key={`opt_${index}`}>
              //               {item.title}
              //             </option>
              //           ))}
              //         </Form.Control>
              //         <Link
              //           className="rounded-2 mr-1 px-2 py-2 btn-primary d-inline-block"
              //           to="/refund"
              //         >
              //           <IconPlus fillColor="#fff" />
              //         </Link>
              //         {errors.accountId && (
              //           <span className="text-danger">
              //             {errors.accountId.message}
              //           </span>
              //         )}
              //       </>
              //     ) : (
              //       <Link
              //         to="/refund"
              //         className="btn btn-primary w-100 rounded-2"
              //       >
              //         افزودن شماره حساب
              //       </Link>
              //     )}

              //     {accounts != null && accounts.length > 0 ? (
              //       <>
              //         <div className="form-control rounded-2 text-center mb-2 d-flex align-items-center">
              //           <NumericFormat
              //             {...register("rialAmount", {
              //               required: "مبلغ را وارد نمایید!",
              //             })}
              //             className="border-0 btn-no-style text-center"
              //             // suffix="تومان"
              //             decimalScale="0"
              //             thousandSeparator=","
              //             placeholder="0"
              //             maxLength={15}
              //             onValueChange={(values) => {
              //               const { value } = values;
              //               setValue("rialAmount", value, {
              //                 shouldValidate: true,
              //               });
              //             }}
              //           />
              //           <span className="text-muted">تومان</span>
              //         </div>
              //         {errors.rialAmount && (
              //           <span className="text-danger">
              //             {errors.rialAmount.message}
              //           </span>
              //         )}
              //         <Button
              //           variant="primary"
              //           className="w-100 rounded-2"
              //           type="submit"
              //           disabled={isSubmitting}
              //         >
              //           {isSubmitting && (
              //             <Spinner
              //               animation="border"
              //               variant="warning"
              //               size="sm"
              //             />
              //           )}
              //           برداشت از کیف پول
              //         </Button>
              //       </>
              //     ) : (
              //       <>
              //         <Form.Control
              //           type="number"
              //           className="rounded-2 my-2 text-center"
              //           placeholder="0 تومان"
              //           disabled
              //         />
              //         <Button
              //           variant="primary"
              //           className="w-100 rounded-2"
              //           disabled
              //         >
              //           برداشت از کیف پول
              //         </Button>
              //       </>
              //     )}
              //   </form>
              // </div>
            )}
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default WalletItem;
